module.exports = __webpack_public_path__ + "static/img/stay-option-icon-swimming.299faa9c.svg";